import {faEnvelope} from "@fortawesome/pro-light-svg-icons/faEnvelope";
import {faHome} from "@fortawesome/pro-light-svg-icons/faHome";
import {faMessages} from "@fortawesome/pro-light-svg-icons/faMessages";
import {faPaperPlane} from "@fortawesome/pro-light-svg-icons/faPaperPlane";
import {faTruckFast} from "@fortawesome/pro-light-svg-icons/faTruckFast";
import {useClientAccountOverview,} from '@twigsby/client-data';
import {
	Badge,
	BuildEntry,
	ColourSolid,
	EntryContent,
	Placement,
	SideNavigationType,
	Tooltip, ToolTipPlacement,
	useLayout,
	useTranslation
} from "@twigsby/frontend-framework";
import React from 'react';
import {NavLink, useLocation} from "react-router-dom";
import {useUKPBAuth} from "../Providers/AuthProvider";
import {Logo} from "./Logo";
import {MapEventToasts} from "./ServiceAlertManager";
import {UserHelpMenu} from "./UserHelpMenu";
import UserMenu from "./UserMenu";

const UnreadSectionBadge = (props: any) => {
	const { t } = useTranslation();
	const overview = useClientAccountOverview();
	const { sidebarOpen, isUltraWide } = useLayout();

	if(!overview?.data?.counts.mailItems?.unread || overview?.data?.counts.mailItems?.unread === 0 ||
		!overview?.data?.counts.messages?.unread || overview?.data?.counts.messages?.unread === 0 ) return null;

	return (
		<Badge
			colour={ColourSolid.Alert}
			value={props.name === 'mail' ? overview?.data?.counts.mailItems.unread : overview?.data?.counts.messages.unread}
			placement={(sidebarOpen || isUltraWide) ? Placement.Right : Placement.TopRight}
		/>
	)
}

const Navigation = (props: SideNavigationType) => {
	const location = useLocation();
	const { t } = useTranslation();

	const { token } = useUKPBAuth();
	const { isMedium, toggleSidebar, sidebarOpen, isUltraWide } = useLayout();

	return (
		<>
			<nav className={`side-navigation dynamic-side-navigation ${props.isBranded ? 'branded' : ''} ${process.env.REACT_APP_ENV_LABEL !== 'Production' ? 'bad-component-highlight staging-component-highlight' : ''}`}>

				{isMedium && (
					<div className={'navigation-group hide-sm'}>
						{props.showLogo && (
							<div className={'navigation-group mb-lg'}>
								<div className={'side-navigation-logo-container'}>
									<Logo />
								</div>
							</div>
						)}
					</div>
				)}

				<div className={'navigation-group main-navigation-group'}>
					<Tooltip content={t('navigation.overview')} position={ToolTipPlacement.Right} disabled={sidebarOpen || !isMedium || isUltraWide}>
						<BuildEntry title={t('navigation.overview')} url={'/'} icon={faHome} />
					</Tooltip>

					<Tooltip content={t('navigation.mailboxes')} position={ToolTipPlacement.Right} disabled={sidebarOpen || !isMedium || isUltraWide}>
						<NavLink
							className={`side-navigation-entry collapsable ${location.pathname.indexOf('/mail/') > -1 ? 'active' : '' }`}
							to={'/mail/inbox'}

						>
							<EntryContent title={t('navigation.mailboxes')} url={'/mail/inbox'} icon={faEnvelope} badge={token ? <UnreadSectionBadge name={'mail'} /> : null} />
						</NavLink>
					</Tooltip>

					<Tooltip content={t('navigation.sendMail')} position={ToolTipPlacement.Right} disabled={sidebarOpen || !isMedium || isUltraWide}>
						<NavLink
							className={`side-navigation-entry collapsable ${location.pathname.indexOf('/send-mail/send') > -1 ? 'active' : '' }`}
							to={'/send-mail/send'}
						>
							<EntryContent title={t('navigation.sendMail')} url={'/send-mail/send'} icon={faPaperPlane} />
						</NavLink>
					</Tooltip>

					<Tooltip content={t('navigation.messageCentre')} position={ToolTipPlacement.Right} disabled={sidebarOpen || !isMedium || isUltraWide}>
						<NavLink
							className={`side-navigation-entry collapsable ${location.pathname.indexOf('/message-centre') > -1 ? 'active' : '' }`}
							to={'/message-centre'}
						>
							<EntryContent title={t('navigation.messageCentre')} url={'/message-centre'} icon={faMessages} badge={token ? <UnreadSectionBadge name={'messages'} /> : null} />
						</NavLink>
					</Tooltip>

					{isMedium && (
						<Tooltip content={t('navigation.shippingCalculator')} position={ToolTipPlacement.Right} disabled={sidebarOpen || !isMedium || isUltraWide}>
							<NavLink
								className={`side-navigation-entry collapsable ${location.pathname.indexOf('/shipping-calculator') > -1 ? 'active' : '' }`}
								to={'/shipping-calculator'}
							>
								<EntryContent title={t('navigation.shippingCalculator')} url={'/shipping-calculator'} icon={faTruckFast} />
							</NavLink>
						</Tooltip>
					)}

					{!isMedium && token && (
						<UserMenu />
					)}
				</div>

				{isMedium && (
					<div className={'navigation-group mt-a pb-xs'}>
						<Tooltip content={t('help.title')} position={ToolTipPlacement.Right} disabled={sidebarOpen || !isMedium || isUltraWide}>
							<UserHelpMenu />
						</Tooltip>

						{token && (
							<MapEventToasts />
						)}

						<div className={'navigation-group mt-a'}>
							<div className={'side-navigation-divider'}></div>
							{token && (
								<UserMenu />
							)}
						</div>
					</div>
				)}
			</nav>
		</>
	);
};

export default Navigation;
